import React, { ReactNode } from "react";
import Switch from "react-switch";
import { useEffect, useState, useRef } from "react";
import "./SwitchTextContainer.scss";

interface IProps {
    preText: ReactNode;
    postText: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    hidePostText?: boolean;
}

export const SwitchTextContainer = (props: IProps) => {
    return (
        <div className="switchTextContainer" onClick={() => props.onChange(!props.checked)}>
            <div className={`switchOverallContainer ${!props.checked && "switchBorderBottom"}`}>
                <Switch
                    width={32}
                    height={16}
                    onChange={props.onChange}
                    checked={props.checked}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#23A866"
                    offColor="#C6C8CE"
                    offHandleColor="#FFFFFF"
                    onHandleColor="#FFFFFF"
                    borderRadius={99}
                    boxShadow="0px 2px 2px rgba(31, 39, 71, 0.1)"
                    handleDiameter={12}
                />
                <div className="switchPreText">{props.preText}</div>
            </div>
            {!props.hidePostText && props.checked && <div className="switchPostText">{props.postText}</div>}
        </div>
    );
};
